(function(document) {

    var selectors = {
        textAccordion: '.text-accordion',
        tipsAccordion: '.text-accordion__title',
    };
  
    var textAccordion = document.querySelector(selectors.textAccordion);
    var tipsAccordion = document.querySelector(selectors.tipsAccordion);
  
    if (tipsAccordion) {
        tipsAccordion.addEventListener("click", function(){
            if (textAccordion.classList.contains("closed")) {
                textAccordion.classList.remove("closed")
                tipsAccordion.querySelector('img').classList.remove("closed")
                textAccordion.querySelector('.text-accordion__content').classList.remove("hidden")
            } else {
                textAccordion.classList.add("closed")
                tipsAccordion.querySelector('img').classList.add("closed")
                textAccordion.querySelector('.text-accordion__content').classList.add("hidden")
            }
        });
    }

})(document);
  